import { apiURL } from '../URLs'
import { account } from '../../classes/Account'
import { getStoredSessionId, setStoredSessionId } from './sessionStorage'

export async function endTrackedSession({ accountId } = {}) {
  const sessionId = getStoredSessionId()
  if (!sessionId) return

  const body = JSON.stringify({
    sessionId,
    reason: 'logout',
    accountId: accountId || account.accountId || undefined
  })

  try {
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      navigator.sendBeacon(`${apiURL}/api/activity/session/end`, new Blob([body], { type: 'application/json' }))
    } else {
      await fetch(`${apiURL}/api/activity/session/end`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-session-id': sessionId,
          ...(account.accessToken ? { Authorization: account.accessToken } : {})
        },
        body,
        keepalive: true,
        credentials: 'include'
      })
    }
  } catch {
    // best-effort
  }

  setStoredSessionId('')
}
